import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Field } from 'app/dynamic-form-builder/models/field.model';

/**
 * Modal que muestra un formulario
 */
@Component({
    selector: 'app-create-dialog',
    templateUrl: './create-dialog.component.html',
    styleUrls: ['./create-dialog.component.scss'],
    standalone: false
})
export class CreateDialogComponent implements OnInit {
  /**
   * Campos del formulario
   */
  fields: Field[];
  /**
   * Boton de envio del formulario
   */
  button: any;

  /**
   * Constructor
   *
   * @param dialogRef servicio de modal
   * @param data data recibida con la info del formulario
   */
  constructor(
    public dialogRef: MatDialogRef<CreateDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(MAT_DIALOG_DATA) public data: { fields: Field[]; button: any; col: string; title: string; extras?: {} }) {
    this.fields = this.data.fields;
    this.button = this.data.button;
  }

  /**
   * Init
   */
  ngOnInit(): void {
  }

  /**
   * Obtiene los campos del formulario
   */
  getFields(): Field[] {
    return this.fields;
  }


  /**
   * Emite el evento de que se lleno todo el formulario
   *
   * @param form informacion del formulario
   */
  create(form: any): void {
    this.dialogRef.close(form);
  }

}
